module.exports = __webpack_public_path__ + "static/our-team-5ae62e9f411b3100cd43d8044f72f36b.gif";